export const SECTION_OPTIONS = [
    { label: "Register", value: "register" },
    { label: "Login", value: "login" },
    { label: "Home Post", value: "homepost" },
    { label: "Home Story", value: "homestory" },
    { label: "MaitriMonial", value: "maitrimonial" },
    { label: "Directory", value: "users" },
    { label: "Marketplace", value: "business" },
    { label: "Bazar Bhav", value: "bazarbhav" },
    { label: "Jobs", value: "job" },
    { label: "Blood Group", value: "bloodgroup" },
    { label: "Notification", value: "notification" },
    { label: "Profile", value: "profile" },
    { label: "Advertisement", value: "advertisement" },
    { label: "Family Tree", value: "familytree" },
    { label: "Followers", value: "followers" },
    { label: "Following", value: "following" },
    { label: "Chat", value: "chat" },
];

export const getSectionLabel = (value: string) =>
    SECTION_OPTIONS.find((s) => s.value === value)?.label || value;
